/* eslint-disable @typescript-eslint/naming-convention */
import { IColors, ITypography } from "@swiggy-private/dls-web-common/dist/components/types.internal";

export type PLBillPrimitiveStyle = Record<string, string | number>;

export interface PLBillDLSProperties {
    textVariant?: keyof ITypography;
    textColor?: keyof IColors;
}

export enum PLBillTextAnimation {
    SHIMMER_LEFT_TO_RIGHT = "SHIMMER_LEFT_TO_RIGHT",
}

export interface PLBillPrimitiveProperties {
    dls?: PLBillDLSProperties;
    style?: PLBillPrimitiveStyle;
}

export interface PLBillIconPrimitive {
    type: "icon";
    icon: string;
    properties?: PLBillPrimitiveProperties;
}

export interface PLBillImagePrimitive {
    type: "rightImage";
    image: string;
    properties?: PLBillPrimitiveProperties;
}

export interface PLBillTextPrimitive {
    type: "text";
    text: string;
    animation?: PLBillTextAnimation;
    properties?: PLBillPrimitiveProperties;
}

export enum PLBillCtaAction {
    ADD_TIP = "addTip",
    MAKE_IT_FREE = "makeItFree",
}

export interface PLBillButtonPrimitive {
    type: "button";
    text: string;
    ctaAction?: PLBillCtaAction;
    properties?: PLBillPrimitiveProperties;
}

export type PLBillPrimitive = PLBillIconPrimitive | PLBillTextPrimitive | PLBillButtonPrimitive | PLBillImagePrimitive;

export interface PLBillItemsColumn {
    items: PLBillPrimitive[];
    info_text?: (PLBillTextPrimitive | PLBillButtonPrimitive | PLBillImagePrimitive)[];
}

export interface PLBillSubTitleItem {
    type: "title";
    details: PLBillItemsColumn[];
}

export interface PLBillSubDisplayItem {
    type: "display";
    details: PLBillItemsColumn[];
}

export type PLBillSubLineItem = PLBillSubTitleItem | PLBillSubDisplayItem;

export interface PLBillTooltipLeftColumn extends PLBillItemsColumn {
    sub_line_items?: PLBillSubLineItem[];
}

export type PLBillTooltipWidth = "L" | "XL" | "XXL" | "XXXL";

export interface PLBillAnalytics {
    screen_name?: string;
    impression_action?: string;
    click_action?: string;
    context?: string;
}

export interface PLBillTooltipLineItem {
    type: "tooltip";
    details: [PLBillTooltipLeftColumn, ...PLBillItemsColumn[]];
    tooltip_width?: PLBillTooltipWidth;
    analytics?: PLBillAnalytics;
}

export interface PLBillDisplayLineItem {
    type: "display";
    details: [PLBillItemsColumn, PLBillItemsColumn];
}

export interface PLBillSeparatorLineItem {
    type: "separator";
}

export interface PLBillBannerHalfCard {
    icon?: string;
    title?: string;
    content?: string[];
    cta_text?: string;
    analytics?: PLBillAnalytics;
}

export interface PLBillBannerSubtitlePart {
    text: string;
    clickable?: boolean;
}

export interface PLBillBannerLineItem {
    type: "banner";
    banner_details: {
        banner_type?: string;
        title?: string;
        subtitle?: PLBillBannerSubtitlePart[];
        icon?: string;
        title_color?: string;
        subtitle_color?: string;
        banner_bg_color?: string;
        half_card?: PLBillBannerHalfCard;
        analytics?: PLBillAnalytics;
    };
}

export type PLBillLineItem =
    | PLBillTooltipLineItem
    | PLBillDisplayLineItem
    | PLBillSeparatorLineItem
    | PLBillBannerLineItem;

export interface PLBillUpsellColumn extends PLBillItemsColumn {
    analytics?: PLBillAnalytics;
}

export interface PLBillHeaderCollapsible {
    type: "collapsible";
    details: [PLBillItemsColumn, PLBillItemsColumn, ...PLBillItemsColumn[]];
    default_state?: "expanded" | "collapsed";
    analytics?: PLBillAnalytics;
    info_text?: PLBillTextPrimitive[];
    upsell?: PLBillUpsellColumn;
}

export type PLBillHeader = PLBillHeaderCollapsible;

export interface PLBillDetailsData {
    header: PLBillHeader[];
    line_items: PLBillLineItem[];
}
